<template>
  <div class="container">
    <p class="title">选购模块</p>

    <div class="titleaction">
      <el-button type="primary" @click="add">添加</el-button>
    </div>

    <div class="tablecontent">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="id" prop="id" width="120">
        </el-table-column>
        <el-table-column label="名称" prop="name" width="180">
        </el-table-column>
        <el-table-column label="状态" prop="status">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status===0?'danger':'success'">{{ scope.row.status === 0 ? "停用" : "生效" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="address">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="EditClick(scope.row)">编辑</el-button>
<!--            <el-button size="small" type="text" @click="deleteRow(scope.row)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination :current-page="pagination.page" :page-size="pagination.pageSize" :total="pagination.total"
                       background layout="total, prev, pager, next" @current-change="handleCurrentChange"
                       @size-change="handleSizeChange"></el-pagination>
      </div>
    </div>

    <el-drawer :visible.sync="drawer" size="80%" title="添加选购模块">
      <div class="editDiv">
        <table class="editTable">
          <tr>
            <td>名称</td>
            <td><input v-model="formdata.name" type="text" /></td>
          </tr>
          <tr>
            <td>名称(英文)</td>
            <td><input v-model="formdata.name_en" type="text" /></td>
          </tr>
          <tr>
            <td>qty</td>
            <td><input v-model="formdata.qty" type="text" /></td>
          </tr>
          <tr>
            <td>总价</td>
            <td><input v-model="formdata.subtotal" type="text" /></td>
          </tr>
          <tr>
            <td>Display template</td>
            <td>
              <p>
                <el-upload :action="`/a1/buy/upimg`" :before-upload="handleBeforeUpload" :http-request="handleUpload"
                           :on-remove="handleRemove" accept=".jpg, .png">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </p>
              <p>
                <ul class="imgList">
                  <li v-for="item,index in img.i1" :key="index">
                    <img :src="`${item}`" />
                    <el-button size="small" type="text" @click="removeImg(index)">删除</el-button>
                  </li>
                </ul>
              </p>
            </td>
          </tr>
          <tr>
            <td>Publicity materials</td>
            <td>
              <p>
                <el-upload :action="`/a1/buy/upimg`" :before-upload="handleBeforeUpload" :http-request="handleUpload2"
                           :on-remove="handleRemove" accept=".jpg, .png">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </p>
              <p>
                <ul class="imgList">
                  <li v-for="item,index in img.i2" :key="index">
                    <img :src="`${item}`" />
                    <el-button size="small" type="text" @click="removeImg2(index)">删除</el-button>
                  </li>
                </ul>
              </p>
            </td>
          </tr>
          <tr>
            <td>Display rack</td>
            <td>
              <p>
                <el-upload :action="`/a1/buy/upimg`" :before-upload="handleBeforeUpload" :http-request="handleUpload3"
                           :on-remove="handleRemove" accept=".jpg, .png">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </p>
              <p>
                <ul class="imgList">
                  <li v-for="item,index in img.i3" :key="index">
                    <img :src="`${item}`" />
                    <el-button size="small" type="text" @click="removeImg3(index)">删除</el-button>
                  </li>
                </ul>
              </p>
            </td>
          </tr>
          <tr>
            <td>状态</td>
            <td>
              <el-select v-model="formdata.statusvalue" placeholder="请选择">
                <el-option v-for="item in formdata.status" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td>绑定商品</td>
            <td>
              <textarea v-model="formdata.goods" cols="30" placeholder="输入商品条码，多个商品用换行符隔开"
                        rows="10"></textarea>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <el-button type="danger" @click="handleDialogConfirm">提交</el-button>
            </td>
          </tr>
        </table>

      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 添加选购模块 begin
      drawer: false,
      innerDrawer: false,
      img: {
        i1: [],
        i2: [],
        i3: [],
      },
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      formdata: {
        id: 0,
        name: "",//选购模块xx
        i1: [],
        i2: [],
        i3: [],
        status: [
          {
            value: "0",
            label: "停用",
          },
          {
            value: "1",
            label: "生效",
          },
        ],
        goods: "", //绑定商品
        statusvalue: "0",
      },
      // 添加选购模块 end
      tableData: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    add() {
      this.drawer = true;
      // 如果有数据，就清空
      this.formdata = {
        id: 0,
        name: "",//选购模块xx
        i1: [],
        i2: [],
        i3: [],
        status: [
          {
            value: "0",
            label: "停用",
          },
          {
            value: "1",
            label: "生效",
          },
        ],
        goods: "", //绑定商品
        statusvalue: "0",
      };
      this.img = {
        i1: [],
        i2: [],
        i3: [],
      };
    },
    //  获取到推荐购买的列表
    getList() {
      this.$axios.get("/a1/buy/list", { params: { page: 1, size: 10 } }).then((res) => {
        this.tableData = res.data.data.data;
      });
    },
    // 分页跳转
    handleCurrentChange() {
    },
    // 每个显示的数量
    handleSizeChange() {
    },
    // 编辑按钮
    EditClick(row) {
      this.formdata.id = row.id;
      this.formdata.name = row.name;
      this.formdata.name_en = row.name_en;
      this.formdata.qty = row.qty;
      this.formdata.subtotal = row.subtotal;

      this.formdata.i1 = row.dis_img.split(",");
      this.formdata.i2 = row.publictity_img.split(",");
      this.formdata.i3 = row.display_rack_img.split(",");
      this.formdata.goods = row.goods.split(",").join("\n");
      this.formdata.statusvalue = row.status + "";

      this.img.i1 = this.formdata.i1;
      this.img.i2 = this.formdata.i2;
      this.img.i3 = this.formdata.i3;
      this.drawer = true;
    },
    // 删除
    deleteRow(row) {
      console.log(row);
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {
        });
    },
    // === 上传部分
    handleBeforeUpload(file) {
      const limit = 3 * 1024 * 1024;
      if (file.size > limit) {
        this.$message.warning("不能超过3MB");
        return false;
      }
    },
    // 统一处理上传图片的函数
    handleUploadCommon(e, targetArray) {
      const formdata = new FormData();
      formdata.append("file", e.file);
      this.$alert("正在上传，请稍候...", {
        showConfirmButton: false,
        showClose: false,
      });
      this.$axios
        .post("/a1/buy/upimg", formdata)
        .then((res) => {
          const { status, data } = res;
          targetArray.push(data.data.upload_url);
        })
        .finally(() => {
          this.$msgbox.close();
        });
    },
    //上传图片1
    handleUpload(e) {
      this.handleUploadCommon(e, this.img.i1);
    },
    // 上传图片2
    handleUpload2(e) {
      this.handleUploadCommon(e, this.img.i2);
    },
    // 上传图片3
    handleUpload3(e) {
      this.handleUploadCommon(e, this.img.i3);
    },
    // 提交
    handleDialogConfirm() {
      if (this.formdata.id) {
        let postData = {
          id: this.formdata.id,
          name: this.formdata.name,
          name_en: this.formdata.name_en,
          qty: parseInt(this.formdata.qty),
          subtotal: parseFloat(this.formdata.subtotal),
          dis_img: this.img.i1,
          publictity_img: this.img.i2,
          display_rack_img: this.img.i3,
          status: parseInt(this.formdata.statusvalue),
          goods: this.formdata.goods,
        };
        this.$axios
          .post("/a1/buy/edit", postData)
          .then((res) => {
            this.getList();
          })
          .finally(() => {
            this.drawer = false;
          });
        this.$alert("编辑成功");
      } else {
        let postData = {
          name: this.formdata.name,
          name_en: this.formdata.name_en,
          qty: parseInt(this.formdata.qty),
          subtotal: parseFloat(this.formdata.subtotal),
          dis_img: this.img.i1,
          publictity_img: this.img.i2,
          display_rack_img: this.img.i3,
          status: parseInt(this.formdata.statusvalue),
          goods: this.formdata.goods,
        };
        this.$axios
          .post("/a1/buy/add", postData)
          .then((res) => {
            this.getList();
          })
          .finally(() => {
            this.drawer = false;
          });
        this.$alert("提交成功");
      }
    },
    handleRemove(file, fileList) {
    },
    // 删除图片
    removeImg(index) {
      this.img.i1.splice(index, 1);
    },
    removeImg2(index) {
      this.img.i2.splice(index, 1);
    },
    removeImg3(index) {
      this.img.i3.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.container {
  border: 1px solid rgb(84, 92, 100);
  width: 100%;
  height: 90%;
}

.title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-indent: 2em;
  color: rgb(84, 92, 100);
  border-bottom: 1px solid rgb(84, 92, 100);
}

.titleaction {
  padding: 10px;
}

.tablecontent {
  width: 100%;
  /* border: 1px solid red; */
}

/* 表格样式 */
.editDiv {
  padding: 0 10px;
}

.editTable {
  /* 设置表格边框为单线条，颜色为浅灰色，合并边框 */
  border-collapse: collapse;
  border: 1px solid #ccc;
  width: 100%;
}

.editTable tr {
  /* 为表格的行设置背景颜色交替效果，增加可读性 */
  background-color: #f9f9f9;
}

.editTable tr:nth-child(even) {
  background-color: #e9e9e9;
}

.editTable td {
  /* 设置单元格内边距，使内容不会紧贴边框 */
  padding: 10px;
  border: 1px solid #ccc;
}

.editTable td:first-child {
  width: 200px;
  text-align: right;
  text-indent: 1em;
  font-weight: 600;
}

.editTable input[type="text"],
.editTable input[type="file"] {
  /* 设置输入框的宽度为100%，使其填满单元格 */
  width: 100%;
  /* 可以根据需要添加其他输入框的样式，比如边框、背景色等 */
  border: 1px solid #ccc;
  padding: 5px;
}

/* 图片列表样式*/
.imgList {
  display: flex;
}

.imgList li img {
  height: 100px;
  max-width: 200px;
}
</style>